/**
 * @file FontGlyph.tsx
 * @description Живой образец «Аа» в подсказке о шрифте элемента (phase19.16,
 * приёмка Р2а, §7.17 п. 3; uiux-fonts-usage §4, §6, §9 вопрос 6): буквы
 * рисуются самим шрифтом, файл грузится, когда подсказка видна (как у
 * `FontSampleText`). Пока грузится — серая заготовка, не загрузился —
 * системный шрифт без подписи.
 */

import { useContext } from "react";

import { Skeleton } from "../../../ui/skeleton";
import { useShopFonts } from "../../../site-view/shop-fonts-context";
import { SiteViewContext } from "../../../site-view/site-view-context";
import { useInView } from "../../../../hooks/useInView";
import { useFontSample } from "../../../../hooks/site-view/useFontSample";

export function FontGlyph({ fontKey, weight }: { fontKey: string; weight: number }) {
  const { ref, visible } = useInView<HTMLSpanElement>();
  const { registry } = useShopFonts();
  // Вне каркаса вида сайта адреса витрины нет — образец системным шрифтом.
  const siteUrl = useContext(SiteViewContext)?.siteUrl ?? null;
  const sample = useFontSample(fontKey, weight, visible, siteUrl, registry);

  // Подложка подсказки — bg-surface-low, поэтому заготовка темнее, иначе её не видно.
  return (
    <span ref={ref} aria-hidden className="flex h-6 w-8 shrink-0 items-center">
      {sample.status === "loading" && visible ? (
        <Skeleton className="h-4 w-6 rounded bg-on-surface/10" />
      ) : (
        <span className="type-body text-on-surface" style={{ fontFamily: sample.fontFamily, fontWeight: sample.weight, lineHeight: 1 }}>
          Аа
        </span>
      )}
    </span>
  );
}
